export const ACTION_TYPES = {
  GET_USER_REQUEST: 'GET_USER_REQUEST',
  GET_USER_REQUEST_SUCCESS: 'GET_USER_REQUEST_SUCCESS',
  GET_USER_REQUEST_FAILURE: 'GET_USER_REQUEST_FAILURE',
};
